import { v4 as uuidv4 } from "uuid";

export const isValidUUID = (id: string): boolean =>
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
        id
    );

export function generateUUID(): string {
    return uuidv4();
}

export function nullIfEmptyString(
    value: string | null | undefined
): string | null {
    return value && value.trim() !== "" ? value : null;
}

export { isValidPhoneNumber } from "./validator";
export { getDayNameInGerman } from "./mapper";
